import { Helmet } from 'react-helmet-async';

import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SpeedDial } from '../../components/SpeedDial';
import {
  PATH_COLLABORATION_MISSIONS_NEW,
  PATH_FOLDER_DEFAULT,
  PATH_FOLDER_MISSIONS,
  PATH_FOLDERS_DEFAULT,
  PATH_MISSION_DEFAULT,
  PATH_MISSION_SUB_MISSIONS,
} from '../../app/constants/paths.constant';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { SubMissions } from './SubMissions';
import { useSubMissionCreationGate } from './hooks/useSubMissionCreationGate.hook';

export const CollaborationMissionsPage = () => {
  const { missionId, folderId, mission } = useMissionContext();

  const { paths } = useBuildPaths(
    {
      folder: PATH_FOLDER_DEFAULT,
      folderMissions: PATH_FOLDER_MISSIONS,
      collaboration: PATH_MISSION_DEFAULT,
      subMissions: PATH_MISSION_SUB_MISSIONS,
      newSubMission: PATH_COLLABORATION_MISSIONS_NEW,
    },
    { folderId, missionId },
  );

  const creationGate = useSubMissionCreationGate(folderId, missionId);

  return (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            'Sous-Missions de la Collaboration',
            mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          { to: PATH_FOLDERS_DEFAULT, label: 'dossiers', key: 'folders' },
          { to: paths.folder, label: 'dossier', key: 'folder' },
          {
            to: paths.folderMissions,
            label: 'missions',
            key: 'folderMissions',
          },
          {
            to: paths.collaboration,
            label: 'collaboration',
            key: 'collaboration',
          },
          { to: paths.subMissions, label: 'sous-missions', key: 'subMissions' },
        ]}
      />
      <PageTitle
        code={mission?.code}
        title={
          mission?.consolidation.title ?? 'Sous-Missions de la Collaboration'
        }
      />
      <SubMissions />
      <SpeedDial
        actions={[
          {
            id: 'createSubMission',
            gate: creationGate,
            icon: <SubdirectoryArrowRightIcon />,
            name: 'Créer Sous-Mission',
            to: paths.newSubMission,
          },
        ]}
        title="Actions possibles sur les Sous-Missions"
      />
    </>
  );
};
